<template>  
    <modal :value="value"
            max-width="500"
            content-class="leads-external-marketing-automation-create-modal modal-device"
            :has-padding="false"
            @input="emitInput">    

        <div class="leads-external-marketing-automation-create-modal-body">
        <form @submit.prevent="saveMarketingAutomationSend">
            <div class="leads-external-marketing-automation-create-modal-body-header">                
                <h1>{{ $t('message.leads.message.marketingSend') }}</h1>
            </div>

            <div class="leads-external-marketing-automation-create-modal-body-inputs">
                <app-stepper-section :label="$t('message.leads.message.dataBase')"
                           class="stepper-section-database">
                    <app-select class="select"
                                v-model="form.databaseId"
                                :data-title="$t('message.spots.message.select')"
                                :data-items="databasesOptions"
                                :clearable="true"
                                :infiniteId="dbInfiniteId"
                                infinite-loading
                                @search="v => searchDatabase(v)"
                                @load="fetchExternalDatabases"
                                @opened="reloadDatabases" />
                </app-stepper-section>

                <app-stepper-section :label="$t('message.leads.message.automationFlow')"
                           class="stepper-section-automation-flow">
                    <app-select class="select"
                                v-model="form.automationFlowId"
                                :data-title="$t('message.spots.message.select')"
                                :data-search="false"
                                :data-items="automationFlowsOptions"
                                :clearable="true" />
                </app-stepper-section>

                <div class="leads-external-marketing-automation-create-modal-body-inputs-date">
                    <v-radio-group v-validate="'required'"
                                    v-model="form.scheduleType"
                                    :error-messages="errors.collect($t('message.marketingGenerics.message.send'))"
                                    :disabled="viewOnly"
                                    name="Envio"
                                    class="leads-external-marketing-automation-create-modal-body-inputs-date-type-selector"
                                    @change="setScheduleType($event)">

                        <v-radio :label="$t('message.marketingGenerics.message.sendNow')"
                                value="NOW"></v-radio>

                        <v-radio :label="$t('message.marketingGenerics.message.schedule')"
                                value="SCHEDULE"></v-radio>

                    </v-radio-group>

                    <div v-if="isScheduled"
                        class="date-picker-wrapper">
                        <app-box-wrapper data-icon="mdi-calendar-multiselect">
                            <app-date-picker class="leads-external-marketing-automation-schedule-date"
                                            :value="form.date"
                                            :disabled="viewOnly"
                                            @input="setDate($event)"></app-date-picker>
                        </app-box-wrapper>

                        <span>{{$t('message.marketingGenerics.message.at')}}</span>

                        <app-box-wrapper data-icon="mdi-clock-outline">
                            <app-hour-picker :value="form.hour"
                                            :readonly="viewOnly"
                                            :datalabel="$t('message.marketingGenerics.message.scheduleTime')"
                                            class="hour"
                                            center
                                            @input="setHour($event)"></app-hour-picker>
                        </app-box-wrapper>
                    </div>                    
                </div>               
            </div>

            <v-card-actions class="leads-external-marketing-automation-create-modal-body-actions">
                <button class="btn btn-extra-round btn-primary">
                    {{ actionLabel }}
                </button>
            </v-card-actions>
        </form>
        </div>
    </modal>  
</template>
  
<script>
import Modal from "@/components/generic/Modal";
import AppStepperSection from "@components/StepperSection";
import AppSelect from '@components/Select'
import AppBoxWrapper from "@components/BoxWrapper";
import AppDatePicker from "@components/DatePicker";
import AppHourPicker from "@components/HourPicker";
import EventBus from "../../../../../../../packages/event-bus";

export default {
components: {
    Modal,
    AppStepperSection,
    AppSelect,
    AppBoxWrapper,
    AppDatePicker,
    AppHourPicker
},
data() {
    return {
    dbInfiniteId: Date.now(),
    dbFilter: undefined,
    page: 0,
    form: {
        id: undefined,
        scheduleType: "NOW",
        date: undefined,
        hour: undefined,
        automationFlowId: undefined,
        databaseId: undefined,
    },    
    databasesList: [],
    automationFlowsList: []
    };
},

props: {
    value: {
        type: Boolean,
        default: false,
    },
    item: {
        
    },
    viewOnly: {
        type: Boolean,
        default: false,
    }
},

watch: {
    value(val) {
    if (val) {
        this.$validator.reset();
        this.fetchExternalTypeAutomationFlows();
        if (this.isEdit) {
            this.setInitialEditData();
        } else {
            this.resetInitialData();
        }
    }
    },
},

computed: {
    isEdit() {
    return !!this.item;
    },    
    actionLabel() {
    return this.isEdit || this.isScheduled ? this.$t('message.generics.message.save') : this.$t('message.leads.message.send');
    },
    isScheduled() {
      return this.form.scheduleType === "SCHEDULE";
    },
    databasesOptions() {
        return this.databasesList && this.databasesList.map((database) => {
        return {
            id: database.id,
            label: database.sourceIdentifier
        }
        })
    },
    automationFlowsOptions() {
        return this.automationFlowsList && this.automationFlowsList.map((automationFlow) => {
        return {
            id: automationFlow.id,
            label: automationFlow.name
        }
        })
    },    
    selectedDate() {
        return this.form.date 
    },   
    selectedHour() {
        return this.form.hour 
    },
    isValidHour() {
        return /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(this.selectedHour)
    }
},

mounted() {
    if (this.isEdit) {
    this.setInitialEditData();
    }
},

methods: {
    resetInitialData() {
    this.form = {
        id: undefined,
        scheduleType: "NOW",
        date: undefined,
        hour: undefined,
        automationFlowId: undefined,
        databaseId: undefined,
    };
    },
    setInitialEditData() {
    this.form = {
        id: this.item.id,
        scheduleType: this.item.date ? "SCHEDULE" : "NOW",
        date: this.item.date.split(" ")[0],
        hour: this.item.date.split(" ")[1],
        automationFlowId: this.item.automationFlowId,
        databaseId: this.item.databaseId
    };
    },
    emitBack() {
    this.$emit("back");
    },
    emitInput(value) {
    this.$emit("input", value);
    },
    hideModal() {
    this.emitInput(false);
    },    
    async saveMarketingAutomationSend() {
        try {
            const isValid = await this.$validator.validateAll();        
            if (isValid) {
                const response = this.validateAutomationFlowAndDatabase()
                if(!response.valid) {
                    return EventBus.$emit("show-message", {
                        type: "ERROR",
                        message: response.message,
                    });
                }
                if(!this.isEdit) {
                    await this.$api.leads.createMarketingAutomationSend({
                    date: this.form.date && this.form.hour ? `${this.form.date} ${this.form.hour}:00` : undefined,
                    automationFlowId: this.form.automationFlowId,
                    databaseId: this.form.databaseId,
                    });
                    this.hideModal()
                    this.$emit("created");
                    EventBus.$emit("show-message", {
                        type: "SUCCESS",
                        message: this.$t('message.successMessages.message.marketingSendCreated'),
                    });
                } else {
                    await this.$api.leads.editMarketingAutomationSend({
                    id: this.form.id,    
                    date: this.form.date && this.form.hour ? `${this.form.date} ${this.form.hour}:00` : undefined,
                    automationFlowId: this.form.automationFlowId,
                    databaseId: this.form.databaseId,
                    });
                    this.hideModal()
                    this.$emit("edited");
                    EventBus.$emit("show-message", {
                        type: "SUCCESS",
                        message: this.$t('message.successMessages.message.marketingSendEdited'),
                    });
                }
            }            
        } catch (error) {
            console.log(error)
        }
    },
    validateAutomationFlowAndDatabase() {
        try {
            if(!this.form.databaseId) throw this.$t('message.errorMessages.message.selectDatabase')
            if(!this.form.automationFlowId) throw this.$t('message.errorMessages.message.selectAutomationFlow')
            if(this.isScheduled && !this.selectedDate) throw this.$t('message.errorMessages.message.selectDate')
            if(this.isScheduled && !this.isValidHour) throw this.$t('message.errorMessages.message.invalidTime')
            return {
                valid: true
            }
        } catch (error) {                
            return {
                valid: false,
                message: error
            }
        }            
    },    
    async fetchExternalDatabases($state) {
        try {
            const databases = await this.$api.leads.listExternalDatabases({
                page: this.page, 
                search: this.dbFilter
            })

            this.page++;

            this.databasesList.push(...databases)

            if ($state) {
                if (databases.length) {
                    $state.loaded();
                } else {
                    this.isComplete = true;
                    $state.complete();
                }
            }
        } catch (error) {
            console.log(error)
        }
    },
    searchDatabase(search) {
        this.dbFilter = search
        this.reloadDatabases()
    },
    reloadDatabases() {
      this.page = 0;

      this.databasesList = [];
      this.dbInfiniteId++;
    },
    async fetchExternalTypeAutomationFlows() {
        try {
            const automationFlows = await this.$api.marketing.automation.flow.listFlowsExternalType()
            this.automationFlowsList = automationFlows
        } catch (error) {
            console.log(error)
        }
    },
    setScheduleType(value) {
        this.form.scheduleType = value
    },
    setDate(event) {
        this.form.date = event
    },
    setHour(event) {
        this.form.hour = event
    }    
},
};
</script>
  
<style lang="scss" scoped>
.leads-external-marketing-automation-create-modal {
.leads-external-marketing-automation-create-modal-body {
    padding: 10px 20px;

    .leads-external-marketing-automation-create-modal-body-header {
    position: relative;

    h1 {
        text-align: center;
        font-size: 32px;
        font-weight: 600;
        margin-bottom: 40px;
    }

    button {
        position: absolute;
        font-size: 30px;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
    }
    }

    .leads-external-marketing-automation-create-modal-body-inputs {
        
        margin: 0 auto 30px;

        .select {
            margin: 0 auto;
        }
        .stepper-section-automation-flow {
            padding-bottom: 10px;
        }

        .leads-external-marketing-automation-create-modal-body-inputs-date {

            width: 90%;
            margin: 0 auto;

            .leads-external-marketing-automation-create-modal-body-inputs-date-type-selector {
                margin: 20px;
                display: flex;
                flex-direction: column;
                align-items: center;           

            }
            .date-picker-wrapper {
                display: flex;
                align-items: center;

                .leads-external-marketing-automation-schedule-date {
                    flex: 1;
                }
            }
        }

        
    }

    .leads-external-marketing-automation-create-modal-body-actions {
    display: flex;
    justify-content: center;
    }
}
}
</style>
  